import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  Type,
} from '@angular/core';
import { Document } from '@contentful/rich-text-types';
import { NodeRenderer } from 'ngx-contentful-rich-text';

import { CalloutType } from './models/callout.enum';

@Component({
  selector: 'nibtravel-callout',
  templateUrl: './callout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutComponent {
  @Input()
  @HostBinding('id')
  containerId!: string;

  @Input() style: CalloutType = CalloutType.Light;

  /** Contentful Rich Text fields */
  @Input() body!: Document;
  @Input() leftSide!: Document;
  @Input() rightSide!: Document;
  @Input() nodeRenderers!: Record<string, Type<NodeRenderer>>;

  @Output() calloutBtnClick = new EventEmitter();

  @HostBinding('class')
  get hostCss(): string {
    return `callout callout--${this.style}`;
  }
}
